import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpgradeMessageNotificationComponent } from './upgrade-message-notification.component';
import { UpgradeMessageNotificationService } from '@fi-app/utilities/notification/upgrade-message-notification/upgrade-message-notification.service';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [UpgradeMessageNotificationComponent],
    imports: [CommonModule, FiAppTextSharedModule, MatButtonModule],
    providers: [UpgradeMessageNotificationService],
})
export class UpgradeMessageNotificationModule {}
